import { gql } from '@apollo/client';

export const DELETE_ENROLMENT = gql`
  mutation deleteEnrolment($id: ID!) {
    enrolment: deleteEnrolment(where: { id: $id }) {
      id
    }
  }
`;
